import styled from "styled-components";

export const Container = styled.div`
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 15px;
`;

export const PageTitle = styled.h1`
  font-weight: 700;
  font-size: 28px;
`;
